import { NgModule, InjectionToken } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { CustomMsalGuard } from './@core/guards/custom-msal.guard';

const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

export const AppRoutes: Routes = [
  {
    path: 'v1',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [CustomMsalGuard]
  },
  {
    path: '',
    redirectTo: '/v1/status',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

const config: ExtraOptions = {
  enableTracing: false, // <-- debugging purposes only
};

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
